import {
  applyEditToRow,
  PricingAccountRow,
} from '@/experiences/sales-portal/domain/pricing/screens/management/blocs/transformers/use-pricing-management-transformers';
import {
  selectPriceEdit,
  usePricingEditsStore,
} from '@sales-portal/domain/pricing/blocs/stores/pricing-edits-store';
import { useMemo } from 'react';
import { useShallow } from 'zustand/shallow';

export const useUpdatedPricingRow = (
  variantPackUUID: string,
  restaurantUUID: string,
  originalRow: PricingAccountRow,
) => {
  const editedPricing = usePricingEditsStore(
    useShallow((state) =>
      selectPriceEdit(state, variantPackUUID, restaurantUUID),
    ),
  );

  const updatedRow: PricingAccountRow = useMemo(
    () =>
      editedPricing ? applyEditToRow(originalRow, editedPricing) : originalRow,
    [editedPricing, originalRow],
  );

  return {
    hasChanges: Boolean(editedPricing),
    updatedRow,
  };
};
